module.exports = __webpack_public_path__ + "img/archetype-selected.6370ad3c.svg";